import * as React from 'react'
import ProjectedBalanceCard from '@/pages/dashboard/widgets/ProjectedBalanceCard'
import ForecastScoreCard from '@/pages/dashboard/widgets/ForecastScoreCard'
import TodoCard from '@/pages/dashboard/widgets/TodoCard'
import DashboardBanner from '@/pages/dashboard/DashboardBanner'
import useBootstrapDashboardView from '@/pages/dashboard/useBootstrapDashboardView'
import useDashboardRefresh from '@/pages/dashboard/useDashboardRefresh'

export default function DashboardPage() {
  useBootstrapDashboardView()
  const refresh = useDashboardRefresh()

  // Edits made in the Table view don't reach most dashboard feeds — they sit
  // on staleTime: Infinity under their own query keys — so arriving at the
  // dashboard refetches them. Mount-only: navigating here IS the trigger.
  React.useEffect(() => {
    refresh()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="h-full overflow-y-auto p-3">
      {/* Content cap from the design (5a): the dashboard stops widening at
          1560px and centres, so an ultrawide monitor doesn't stretch the
          chart and banner into unreadable bands. */}
      <div className="mx-auto w-full max-w-[1560px]">
        <div className="mb-3">
          <DashboardBanner />
        </div>
        <div className="dashboard-grid">
          <div className="db-score min-w-0">
            <ForecastScoreCard />
          </div>
          <div className="db-chart min-w-0" id="projected-balance-card">
            <ProjectedBalanceCard />
          </div>
          <div className="db-todo min-w-0">
            <TodoCard />
          </div>
        </div>
      </div>
    </div>
  )
}
